"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Offer = void 0;
var _react = _interopRequireDefault(require("react"));
var _emailUtils = require("../../../../utils/emailUtils");
var _userflow = require("../../../../utils/userflow");
var _date = require("../../../../utils/date");
var _userflow2 = _interopRequireDefault(require("../../../../styles/userflow"));
var _CurrencyFormat = _interopRequireDefault(require("../../../CurrencyFormat"));
var _userflow3 = require("../../../../constants/userflow");
var _Grid = _interopRequireDefault(require("../common/Grid"));
var _Spacer = _interopRequireDefault(require("../common/Spacer"));
var _Container = _interopRequireDefault(require("../Container"));
var _PriceDirection = _interopRequireDefault(require("../PriceDirection"));
var _SurchargeAnnotation = _interopRequireDefault(require("../SurchargeAnnotation"));
var _Button = _interopRequireDefault(require("../common/Button"));
var _pluralizeUtils = require("../../../../utils/pluralizeUtils");
var TOURIST_WORD_FORMS = ['', 'одного', 'двоих', 'троих', 'четверых', 'пятерых', 'шестерых', 'семерых'];
var styles = {
  container: {
    padding: '0px 10px',
    textAlign: 'center'
  },
  offerText: {
    fontSize: '14px',
    lineHeight: '16px',
    color: _userflow2["default"].colors.blackBase,
    mobile: {
      fontSize: '13px'
    }
  },
  title: {
    fontSize: '22px',
    lineHeight: '27px',
    fontWeight: 500,
    color: _userflow2["default"].colors.blackBase,
    mobile: {
      fontSize: '16px',
      lineHeight: '19px'
    }
  },
  titleNeutral: {
    fontWeight: 'normal',
    fontSize: '22px',
    lineHeight: '27px',
    mobile: {
      fontSize: '16px',
      lineHeight: '19px'
    }
  },
  description: {
    fontSize: '18px',
    lineHeight: '21px',
    color: _userflow2["default"].colors.blackLight,
    mobile: {
      fontSize: '16px',
      lineHeight: '18px'
    }
  },
  buttonWrapper: {
    backgroundColor: _userflow2["default"].colors.white,
    textAlign: 'center'
  },
  buttonTitle: {
    fontSize: '18px',
    lineHeight: '21px',
    display: 'block'
  },
  buttonDescription: {
    fontSize: '12px',
    lineHeight: '14px',
    color: _userflow2["default"].colors.blackLight,
    fontWeight: 'normal',
    display: 'block'
  },
  flexSign: {
    background: '#E6E9EE',
    borderRadius: '4px',
    padding: '2px 4px',
    fontSize: '12px'
  },
  delimeter: {
    width: '96px',
    margin: '0 auto',
    backgroundColor: '#E6E9EE',
    height: '1px',
    border: 0
  },
  moonIcon: {
    verticalAlign: 'middle'
  }
};
var Title = (0, _emailUtils.adaptiveStyled)('span', styles.title);
var TitleNeutral = (0, _emailUtils.adaptiveStyled)('span', styles.titleNeutral);
var OfferText = (0, _emailUtils.adaptiveStyled)('div', styles.offerText);
var DiffDescription = (0, _emailUtils.adaptiveStyled)('div', styles.description);
var priceDirectionTitle = function priceDirectionTitle(_ref) {
  var destinationName = _ref.destinationName,
    preposition = _ref.preposition,
    direction = _ref.direction;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_PriceDirection["default"], {
    direction: direction,
    withText: true
  }), /*#__PURE__*/_react["default"].createElement(TitleNeutral, null, "\u0446\u0435\u043D\u0430 \u043D\u0430 \u0442\u0443\u0440\u044B ", preposition), " ".concat(destinationName, " "));
};
var priceAppearedTitle = function priceAppearedTitle(_ref2) {
  var destinationName = _ref2.destinationName,
    preposition = _ref2.preposition;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(TitleNeutral, null, "\u041F\u043E \u0432\u0430\u0448\u0435\u0439 \u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0435 ", preposition), " ".concat(destinationName, " "), /*#__PURE__*/_react["default"].createElement(TitleNeutral, null, "\u043F\u043E\u044F\u0432\u0438\u043B\u0438\u0441\u044C".concat(_userflow3.NBSP, "\u0442\u0443\u0440\u044B")));
};
var recommendedHotelTitle = function recommendedHotelTitle(_ref3) {
  var hotelName = _ref3.hotelName;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(TitleNeutral, null, "\u041F\u043E\u044F\u0432\u0438\u043B\u0430\u0441\u044C \u043E\u0447\u0435\u043D\u044C \u0432\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430 \u043F\u043E \u0432\u0430\u0448\u0435\u043C\u0443 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044E \u0432 \u043E\u0442\u0435\u043B\u044C"), " ".concat(hotelName, " "));
};
var priceStableTitle = function priceStableTitle(_ref4) {
  var destinationName = _ref4.destinationName,
    preposition = _ref4.preposition;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(TitleNeutral, null, "\u0426\u0435\u043D\u0430 \u043D\u0430 \u0442\u0443\u0440\u044B ", preposition), " ".concat(destinationName, " "), /*#__PURE__*/_react["default"].createElement(TitleNeutral, null, "\u0432 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u043C\u0435\u043D\u044F\u0435\u0442\u0441\u044F".concat(_userflow3.NBSP, "\u043C\u0430\u043B\u043E")));
};
var chooseTitleBuilder = function chooseTitleBuilder(type, subtype) {
  switch ("".concat(type, "|").concat(subtype)) {
    case 'min_price|price_fell':
      return priceDirectionTitle;
    case 'min_price|price_appeared':
      return priceAppearedTitle;
    case 'recommended_hotel|price_fell':
      return recommendedHotelTitle;
    case 'recommended_hotel|price_appeared':
      return recommendedHotelTitle;
    case 'price_up|price_up':
      return priceDirectionTitle;
    case 'price_up|price_up_after_min_price_alert':
      return priceDirectionTitle;
    case 'price_stable|price_stable':
      return priceStableTitle;
    default:
      return "Wrong type: ".concat(type, " or subtype: ").concat(subtype);
  }
};
var priceDiff = function priceDiff(diffPercentage, direction, diffPrice, oldPrice) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 8
  }), /*#__PURE__*/_react["default"].createElement(DiffDescription, null, "\u042D\u0442\u043E \u0432\u044B\u0433\u043E\u0434\u043D\u0435\u0435 \u043D\u0430 ".concat(diffPercentage, "%"), /*#__PURE__*/_react["default"].createElement(_PriceDirection["default"], {
    direction: direction
  }), ' ', /*#__PURE__*/_react["default"].createElement(_CurrencyFormat["default"], {
    value: diffPrice
  }), ",", /*#__PURE__*/_react["default"].createElement("br", null), 'от предыдущей цены — ', /*#__PURE__*/_react["default"].createElement(_CurrencyFormat["default"], {
    value: oldPrice
  })));
};
var flexSign = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, _userflow3.NBSP, /*#__PURE__*/_react["default"].createElement("span", {
  style: styles.flexSign
}, "\xB12"));
var extractName = function extractName(destinationName) {
  var words = destinationName.split(' ');
  return words.slice(1, words.length).join(' ');
};
var extractPreposition = function extractPreposition(destinationName) {
  var words = destinationName.split(' ');
  return words.slice(0, 1);
};
var Offer = exports.Offer = function Offer(_ref5) {
  var date = _ref5.start_date,
    nights = _ref5.nights_count,
    touristsCount = _ref5.tourists_count,
    destinationName = _ref5.destination_name,
    hotelName = _ref5.hotel_name,
    departureCity = _ref5.departure_city,
    offerType = _ref5.type,
    offerSubtype = _ref5.subtype,
    price = _ref5.price,
    surcharge = _ref5.surcharge,
    isFlexDates = _ref5.flex_dates,
    isFlexNights = _ref5.flex_nights,
    _ref5$price_diff = _ref5.price_diff,
    direction = _ref5$price_diff.direction,
    oldPrice = _ref5$price_diff.old_price,
    diffPrice = _ref5$price_diff.diff_price,
    diffPercentage = _ref5$price_diff.diff_percentage,
    offerLink = _ref5.offer_link;
  var pluralNights = (0, _userflow.pluralize)(nights, _userflow3.NIGHT_WORD_FORMS);
  var formattedNights = " \u043D\u0430".concat(_userflow3.NBSP).concat(nights).concat(_userflow3.NBSP).concat(pluralNights);
  var startDate = (0, _date.formatDate)(date, 'd MMMM');
  var shortenStartDate = (0, _date.formatDate)(date, 'd MMM');
  var buildTitle = chooseTitleBuilder(offerType, offerSubtype);
  var isPriceFell = offerSubtype === 'price_fell';
  var destinationPlaceName = extractName(destinationName);
  var destinationPreposition = extractPreposition(destinationName);

  // TODO: buildTitle либо строка, либо функция с разным кол-ом аргументов
  // @ts-ignore
  var title = buildTitle({
    destinationName: destinationPlaceName,
    hotelName: hotelName,
    preposition: destinationPreposition,
    direction: direction
  });
  var isRecommendedHotel = offerType === 'recommended_hotel';
  var touristsCountText = (0, _pluralizeUtils.pluralizeTouristsCount)(touristsCount);
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    style: styles.container,
    bgColor: "#fff",
    className: "offer"
  }, /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 13
  }), /*#__PURE__*/_react["default"].createElement(OfferText, null, "\u0412\u044B \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u044B \u043D\u0430 \u0442\u0443\u0440\u044B ", isRecommendedHotel ? "".concat(destinationPreposition, " ").concat(destinationPlaceName) : null, " \u0441 ".concat(startDate), isFlexDates && flexSign, formattedNights, isFlexNights && flexSign, ", \u043D\u0430 ".concat(touristsCountText), " \u0438\u0437 ".concat(departureCity)), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 7
  }), /*#__PURE__*/_react["default"].createElement(Title, null, title, /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 4
  }), /*#__PURE__*/_react["default"].createElement("hr", {
    style: styles.delimeter
  }), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 5
  }), "\u041A\u0443\u043F\u0438\u0442\u0435 \u0442\u0443\u0440 \u0441\u0435\u0439\u0447\u0430\u0441 \u0437\u0430".concat(_userflow3.NBSP), /*#__PURE__*/_react["default"].createElement(_CurrencyFormat["default"], {
    value: price
  })), isPriceFell && priceDiff(diffPercentage, direction, diffPrice, oldPrice), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 16
  }), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    style: styles.buttonWrapper
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    link: offerLink
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: styles.buttonTitle
  }, 'Купить тур за ', /*#__PURE__*/_react["default"].createElement(_CurrencyFormat["default"], {
    value: price
  })), /*#__PURE__*/_react["default"].createElement("span", {
    style: styles.buttonDescription
  }, "".concat(shortenStartDate, " ").concat(nights, " "), /*#__PURE__*/_react["default"].createElement("img", {
    width: 9,
    src: (0, _emailUtils.getImage)('moon.png'),
    alt: "\u043D\u043E\u0447\u0435\u0439",
    title: "\u043D\u043E\u0447\u0435\u0439",
    style: styles.moonIcon
  }), " \u043D\u0430 ".concat(TOURIST_WORD_FORMS[touristsCount])))), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 5
  }), /*#__PURE__*/_react["default"].createElement(_SurchargeAnnotation["default"], null, surcharge !== null ? 'Включает доплаты ' : 'Возможны доплаты от туроператора', surcharge !== null ? /*#__PURE__*/_react["default"].createElement(_CurrencyFormat["default"], {
    value: surcharge
  }) : null), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 10
  }));
};